import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../context/AuthContext';
import useMsal from '../../auth/useMsal';
import { LoginWrapper } from './LoginPage.styles';

const Login = () => {
    const { loginAzAd } = useMsal();
    const navigate = useNavigate();
    const { loggedInUser } = useAuthStore();

    // If user is already authenticated (e.g., returned from MSAL redirect), go to home
    useEffect(() => {
        if (loggedInUser) {
            navigate('/home', { replace: true });
        }
    }, [loggedInUser, navigate]);

    return (
        <LoginWrapper>
            <h1>Commodity Book</h1>
            <div>
                <p>Please click on the button below to enter OrcaWeb.</p>
                <button onClick={loginAzAd}>Sign in</button>
            </div>
        </LoginWrapper>
    );
};

export default Login;
